import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';
import { GetTransactionsParams, GetTransactionsResponse, TransactionDetailsResponse } from './dto';
import { bigIntResponseHandler } from 'shared/libs/helpers';
import { TransactionFilters } from '../model/types';
import { setMonthSpend } from 'shared/config/store/reducers/accountsSlice';
import { EMI } from 'shared/model/types';

const transactionApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFilters: build.query<ApiResponse<{ filters: TransactionFilters[] }>, { accountId: number }>({
      query: ({ accountId }) => ({
        url: `private/river/${accountId}/transaction/filters`,
        method: 'GET'
      })
    }),
    getMonthSpend: build.query<ApiResponse<number>, { accountId: number, start: string }>({
      query: ({ accountId, start }) => ({
        url: `private/river/${accountId}/summspendtransactions`,
        method: 'GET',
        params: { start }
      }),
      onQueryStarted: async ({ accountId }, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          console.log(data);
          dispatch(
            setMonthSpend({
              accountId,
              monthSpend: data.response || 0,
              emi: EMI.Wallester
            })
          );
        } catch (e) {
          console.log(e);
        }
      }
    }),
    getTransactions: build.query<
      ApiResponse<GetTransactionsResponse>,
      {
        accountId: number;
        params: GetTransactionsParams;
        merge?: boolean;
      }
    >({
      query: ({ accountId, params }) => ({
        url: `private/river/${accountId}/transactions`,
        method: 'GET',
        responseHandler: bigIntResponseHandler,
        params
      }),
      merge: (current, response, { arg }) => {
        if (arg.merge) {
          current.response = {
            ...response.response,
            transactions: current.response.transactions.concat(response.response.transactions)
          };
        } else {
          return response;
        }
      },

      serializeQueryArgs: ({ endpointName }) => endpointName,
      forceRefetch: ({ currentArg, previousArg }) => {
        return (
          currentArg?.params.page !== previousArg?.params.page ||
          currentArg?.params.page === 1 ||
          currentArg?.accountId !== previousArg?.accountId
        );
      },
      providesTags: ['transactions']
    }),
    getHoldById: build.query<ApiResponse<unknown>, { accountId: number; transactionId: string }>({
      query: ({ accountId, transactionId }) => ({
        url: `private/river/${accountId}/hold/${transactionId}`,
        method: 'GET'
      })
    }),
    getHolds: build.query<ApiResponse<unknown>, { accountId: number }>({
      query: ({ accountId }) => ({
        url: `private/river/${accountId}/holds`,
        method: 'GET'
      })
    }),
    getTransactionById: build.query<
      ApiResponse<TransactionDetailsResponse>,
      { accountId: number | string; transactionId: string }
    >({
      query: ({ accountId, transactionId }) => ({
        url: `private/river/${accountId}/transaction/${transactionId}`,
        method: 'GET'
      })
    })
  })
});

export const {
  useGetHoldByIdQuery,
  useGetHoldsQuery,
  useGetTransactionByIdQuery,
  useLazyGetTransactionByIdQuery,
  useLazyGetTransactionsQuery,
  useGetFiltersQuery,
  useGetMonthSpendQuery,
  useLazyGetMonthSpendQuery
} = transactionApi;

export default transactionApi;
